<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :title="isAddPopup ? '템플릿 추가' : '템플릿 수정'" width="600px" @close="close()">
    <div slot="content">
      <el-form :model="formData" :rules="rules" ref="trgForm">
        <el-row>
          <el-form-item prop="grpId" label="템플릿 그룹">
            <el-select v-model="formData.grpId" style="width: 100%" :disabled="formData.editableFlag === 'N'">
              <el-option v-for="grp in grpList" :key="grp.grpId" :label="grp.grpName" :value="grp.grpId"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item prop="triggerName" label="템플릿 이름">
            <el-input v-model="formData.triggerName" placeholder="입력해주세요."></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item prop="triggerDesc" label="템플릿 설명">
            <el-input v-model="formData.triggerDesc" placeholder="입력해주세요."></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item prop="authority" label="템플릿 수행 권한">
            <el-select v-model="formData.authority" style="width: 100%">
              <el-option v-for="auth in mgrAuthList" :key="auth.basicinfoSubid" :label="auth.basicinfoSubname" :value="auth.basicinfoSubid"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-form-item>
          <el-row type="flex">
            <div class="title-popup-s mr-r4">스케줄 설정</div>
            <el-switch v-model="formData.scheduleApplyFlag" active-value="Y" inactive-value="N"></el-switch>
          </el-row>
          <w-ams-period-setting-component v-show="formData.scheduleApplyFlag === 'Y'" ref="periodSettingCmp"/>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil, isEqual, cloneDeep } from 'lodash';
import msgUtil from '@/utils/message';
import amsSettingsApi from '@/api/settings/server/ams-settings';
import basicinfoSubApi from '@/api/model/basicinfo-sub';

import WAmsPeriodSettingComponent from '../components/AmsPeriodSettingComponent';

export default {
  name: 'WTriggerSettingPopup',
  components: { WAmsPeriodSettingComponent },
  props: {
    selectedTrigger: {
      type: Object,
      default: null,
    },
    selectedGroup: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      rules: {
        triggerName: [
          { required: true, validator: this.validateTriggerName, trigger: 'blur' },
        ],
        grpId: [
          { required: true, validator: this.validateFieldInfo, trigger: 'blur' },
        ],
        authority: [
          { required: true, message: '필수 정보입니다.', trigger: 'blur' },
        ],
      },
      formData: {
        grpId: '',
        triggerId: '',
        triggerName: '',
        triggerDesc: '',
        authority: 'SDUSER',
        creatorId: '',
        creatorDatetime: '',
        scheduleExpression: '',
        scheduleApplyFlag: 'N',
      },
      mgrAuthList: [],
      grpList: [],
    };
  },
  computed: {
    isAddPopup() {
      return isNil(this.selectedTrigger);
    },
  },
  watch: {
    'formData.scheduleApplyFlag': {
      handler(flag) {
        if (!isNil(flag)) {
          if (!this.isAddPopup && flag === 'Y') {
            if (this.selectedTrigger.scheduleApplyFlag === 'N') {
              const currentDate = new Date();
              let cronDate = '';
              cronDate = `0 ${currentDate.getMinutes()} ${currentDate.getHours()} ${currentDate.getDate()} ${currentDate.getMonth() + 1} * ${currentDate.getFullYear()}`;
              this.$refs.periodSettingCmp.setPeriodSettingDataByCronExpression({ scheduleExpression: cronDate });
            } else {
              this.$nextTick(() => {
                this.$refs.periodSettingCmp.setPeriodSettingDataByCronExpression(this.selectedTrigger);
              });
            }
          } else if (this.isAddPopup && flag === 'Y') {
            this.$nextTick(() => {
              const currentDate = new Date();
              let cronDate = '';
              cronDate = `0 ${currentDate.getMinutes()} ${currentDate.getHours()} ${currentDate.getDate()} ${currentDate.getMonth() + 1} * ${currentDate.getFullYear()}`;
              this.$refs.periodSettingCmp.setPeriodSettingDataByCronExpression({ scheduleExpression: cronDate });
            });
          }
        }
      },
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      basicinfoSubApi.getList('MANAGER_AUTH').then((res) => {
        if (res.data.success) {
          this.mgrAuthList = res.data.data;
        }
      });
      this.loadGroupData();
      if (!this.isAddPopup) {
        this.formData = cloneDeep(this.selectedTrigger);
      }
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.$refs.trgForm.resetFields();
      this.$refs.periodSettingCmp.init();
      this.formData = {
        grpId: '',
        triggerId: '',
        triggerName: '',
        triggerDesc: '',
        authority: 'SDUSER',
        creatorId: '',
        creatorDatetime: '',
        scheduleExpression: '',
        scheduleApplyFlag: 'N',
      };
    },
    loadGroupData() {
      amsSettingsApi.getAmsGrpList({ grpType: 'TRIGGER' }).then((response) => {
        if (response.data.success) {
          this.grpList = response.data.data;
          if (this.isAddPopup && isNil(this.selectedGroup)) {
            this.formData.grpId = this.grpList.length > 0 ? this.grpList[0].grpId : '';
          } else if (!isNil(this.selectedGroup)) {
            this.formData.grpId = this.selectedGroup.grpId;
          }
        }
      });
    },
    /**
     * 템플릿 이름 중복 체크
     * @author jeee12
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validateTriggerName(rule, value, callback) {
      if (isNil(value) || value === '') {
        return callback(new Error('필수 정보입니다.'));
      }
      const isModified = this.isAddPopup || !isEqual(value, this.selectedTrigger.triggerName);
      const params = { triggerName: value };
      if (this.formData.triggerId) {
        params.triggerId = this.selectedTrigger.triggerId;
      }
      amsSettingsApi.checkTriggerNameValidation(params).then((response) => {
        const isUniq = response.data.data;
        if (isModified && !isUniq) {
          callback(new Error('이미 사용 중인 템플릿 이름입니다.'));
        }
        callback();
      });
      return true;
    },
    validateFieldInfo(rule, value, callback) {
      if (isNil(value) || value === '') {
        callback(new Error('필수 정보입니다.'));
      } else {
        callback();
      }
    },
    /**
     * 저장 버튼 클릭
     * @author jeee12
     * @return {[type]} [description]
     */
    onSaveButton() {
      this.$refs.trgForm.validate().then((valid) => {
        if (valid) {
          const saveTimingInfo = new Date().getTime();
          const scheduleExpression = this.$refs.periodSettingCmp.getPeriodSettingDataByCronExpression();
          if (this.formData.scheduleApplyFlag === 'Y') {
            if (this.$refs.periodSettingCmp.isOnceValidationFlag === true) {
              this.$message(msgUtil.getCustomMsgData('현재보다 과거 일시는 선택할 수 없습니다.'));
            } else {
              const cron = scheduleExpression.split(' ');
              const second = cron[0];
              const minutes = cron[1];
              const hours = cron[2];
              const dayOfMonth = cron[3];
              const month = cron[4];
              const year = cron[6];
              const starttime = new Date(`${year}-${month}-${dayOfMonth} ${hours}:${minutes}:${second}`);
              if (starttime.getTime() < saveTimingInfo) {
                this.$message(msgUtil.getCustomMsgData('현재보다 과거 일시는 선택할 수 없습니다.'));
              } else {
                this.formData.scheduleExpression = scheduleExpression;
                this.savaTriggerInfo(this.formData);
              }
            }
          } else {
            delete this.formData.scheduleExpression;
            this.savaTriggerInfo(this.formData);
          }
        }
      }).catch(() => {});
    },
    savaTriggerInfo(formData) {
      amsSettingsApi.insertTrigger(formData).then((response) => {
        const target = '템플릿';
        const action = this.isAddPopup ? msgUtil.action.ADD : msgUtil.action.MODIFY;
        if (response.data.success) {
          this.close();
          this.$emit('re-load');
        }
        this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/TriggerSetting/popup/TriggerSettingPopup.vue